import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import myConnections from "../../utility/connect";
const sliceName = "tierSlice";

const initialState = {
  tiers: [],
};

let getTiers = async (_, thunkAPI) => {
  const response = await myConnections.get({
    path: "sifrarnici_protected/get_levels",
    data: {},
    headers: {},
    thunkAPI: thunkAPI,
  });

  return response;
};

getTiers = createAsyncThunk(`${sliceName}/getTiers`, getTiers);
getTiers.myLC = {
  pending: (state, action) => {},
  fulfilled: (state, action) => {
    state.tiers = action.payload.items.map((tier) => {
      const myTier = {
        ...tier,
        id: tier.code,
        badgeImageCode: tier.image_code,
        userImageCode: tier.user_images_code,
        max_points: tier.max_points ?? Infinity,
        decorations: tier.decorations === "Y"
      
      };
      delete myTier.image_code;
      delete myTier.user_images_code;
      return myTier;
    });
  },
  rejected: (state, action) => {},
};

const tierSlice = createSlice({
  name: sliceName,
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getTiers.pending, getTiers.myLC.pending);
    builder.addCase(getTiers.fulfilled, getTiers.myLC.fulfilled);
    builder.addCase(getTiers.rejected, getTiers.myLC.rejected);
  },
});

export const asyncActions = { getTiers };
export const actions = tierSlice.actions;
export default tierSlice.reducer;
